(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elena-gallery"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('elena-gallery')){
 customElements.define('elena-gallery',class extends HTMLElement{
  connectedCallback(){
   if(this.controller)return;
   this.controller=new AbortController();const options={signal:this.controller.signal};this.track=this.querySelector('.elena-gallery__track');
   this.querySelector('[data-prev]')?.addEventListener('click',()=>this.move(-1),options);
   this.querySelector('[data-next]')?.addEventListener('click',()=>this.move(1),options);
   if(this.dataset.autoplay==='true'&&!matchMedia('(prefers-reduced-motion: reduce)').matches){this.timer=setInterval(()=>{if(!this.matches(':hover')&&!this.contains(document.activeElement)&&!document.hidden)this.move(1)},Number(this.dataset.delay)||5000)}
  }
  move(direction){const width=this.track.querySelector('.elena-gallery__card')?.getBoundingClientRect().width||0;const gap=parseFloat(getComputedStyle(this.track).gap)||0;const max=this.track.scrollWidth-this.track.clientWidth;let next=this.track.scrollLeft+direction*(width+gap);if(next>max+2)next=0;if(next<0)next=max;this.track.scrollTo({left:next,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})}
  disconnectedCallback(){this.controller?.abort();this.controller=null;clearInterval(this.timer)}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elena-reviews"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('elena-reviews')){
 customElements.define('elena-reviews',class extends HTMLElement{
  connectedCallback(){
   if(this.controller)return;
   this.controller=new AbortController();const options={signal:this.controller.signal};this.track=this.querySelector('.elena-reviews__track');
   this.querySelector('[data-prev]')?.addEventListener('click',()=>this.move(-1),options);
   this.querySelector('[data-next]')?.addEventListener('click',()=>this.move(1),options);
   if(this.dataset.autoplay==='true'&&!matchMedia('(prefers-reduced-motion: reduce)').matches){this.timer=setInterval(()=>{if(!this.matches(':hover')&&!this.contains(document.activeElement)&&!document.hidden)this.move(1)},Number(this.dataset.delay)||5000)}
  }
  move(direction){const width=this.track.querySelector('article')?.getBoundingClientRect().width||0;const gap=parseFloat(getComputedStyle(this.track).gap)||0;const max=this.track.scrollWidth-this.track.clientWidth;let next=this.track.scrollLeft+direction*(width+gap);if(next>max+2)next=0;if(next<0)next=max;this.track.scrollTo({left:next,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})}
  disconnectedCallback(){this.controller?.abort();this.controller=null;clearInterval(this.timer)}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reka-promo-rotation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('reka-promo-rotation')) {
    customElements.define('reka-promo-rotation', class extends HTMLElement {
      connectedCallback() {
        clearInterval(this.timer);
        this.items = Array.from(this.querySelectorAll('[data-promo-item]'));
        this.index = Math.max(0, this.items.findIndex(item => item.classList.contains('is-active')));
        if (this.items.length < 2) return;
        this.timer = setInterval(() => {
          if (document.hidden) return;
          this.items[this.index].classList.remove('is-active');
          this.items[this.index].setAttribute('aria-hidden', 'true');
          this.index = (this.index + 1) % this.items.length;
          this.items[this.index].classList.add('is-active');
          this.items[this.index].removeAttribute('aria-hidden');
        }, 4000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-testimonial-12"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lm-testimonial-carousel')) {
    customElements.define('lm-testimonial-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.cards = Array.from(this.querySelectorAll('[data-review]'));
        this.dots = Array.from(this.querySelectorAll('[data-review-dot]'));
        if (!this.cards.length) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.mobile = window.matchMedia('(max-width: 1023px)');
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.current = Math.min(Number(this.dataset.initial) || 0, this.cards.length - 1);
        this.manualPause = false;
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.go(index, true), options));
        this.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const index = event.key === 'Home' ? 0 : event.key === 'End' ? this.cards.length - 1 : this.current + (event.key === 'ArrowRight' ? 1 : -1);
          this.go(index, true);
          this.dots[this.current]?.focus({ preventScroll: true });
        }, options);
        const stage = this.querySelector('.lm-testimonials__stage');
        stage.addEventListener('pointerdown', (event) => {
          if (event.button !== 0 || event.target.closest('a, button, input, video')) return;
          this.start = { x: event.clientX, y: event.clientY };
        }, options);
        stage.addEventListener('pointerup', (event) => {
          if (!this.start) return;
          const dx = event.clientX - this.start.x;
          const dy = event.clientY - this.start.y;
          this.start = null;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.4) this.go(this.current + (dx < 0 ? 1 : -1), true);
        }, options);
        stage.addEventListener('pointercancel', () => { this.start = null; }, options);
        this.addEventListener('mouseenter', () => this.stop(), options);
        this.addEventListener('mouseleave', () => this.play(), options);
        this.addEventListener('focusin', () => this.stop(), options);
        this.addEventListener('focusout', () => this.play(), options);
        this.mobile.addEventListener('change', () => this.render(), options);
        this.reduced.addEventListener('change', () => { this.stop(); this.play(); }, options);
        document.addEventListener('visibilitychange', () => document.hidden ? this.stop() : this.play(), options);
        this.addEventListener('shopify:block:select', (event) => {
          const index = this.cards.indexOf(event.target.closest('[data-review]'));
          if (index >= 0) this.go(index, true);
        }, options);
        this.render();
        this.play();
      }
      go(index, manual = false) {
        this.current = (index + this.cards.length) % this.cards.length;
        if (manual) { this.manualPause = true; this.stop(); }
        this.render();
      }
      render() {
        const total = this.cards.length;
        this.cards.forEach((card, index) => {
          const active = index === this.current;
          const previous = total > 1 && index === (this.current - 1 + total) % total;
          const next = total > 2 && index === (this.current + 1) % total;
          card.classList.toggle('is-active', active);
          card.classList.toggle('is-previous', previous);
          card.classList.toggle('is-next', next);
          const visible = active || (!this.mobile.matches && (previous || next));
          card.setAttribute('aria-hidden', String(!visible));
          card.inert = !visible;
        });
        this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === this.current)));
      }
      play() {
        this.stop();
        if (this.dataset.autoplay !== 'true' || this.manualPause || this.reduced.matches || document.hidden || this.matches(':hover, :focus-within') || this.cards.length < 2) return;
        this.timer = setInterval(() => this.go(this.current + 1), Math.max(Number(this.dataset.delay) || 5000, 3000));
      }
      stop() { clearInterval(this.timer); }
      disconnectedCallback() { this.stop(); this.controller?.abort(); this.controller = null; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('store-footer')) {
    customElements.define('store-footer', class extends HTMLElement {
      connectedCallback() {
        this.media = window.matchMedia('(max-width: 749px)');
        this.update = () => this.querySelectorAll('details').forEach(detail => { detail.open = !this.media.matches; });
        this.preventDesktopToggle = event => {
          if (!this.media.matches && event.target.closest('summary')) event.preventDefault();
        };
        this.media.addEventListener('change', this.update);
        this.addEventListener('click', this.preventDesktopToggle);
        this.update();
      }
      disconnectedCallback() {
        this.media.removeEventListener('change', this.update);
        this.removeEventListener('click', this.preventDesktopToggle);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-services"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('store-service-strip')) {
    customElements.define('store-service-strip', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const list = this.querySelector('.store-services__list');
        const buttons = [...this.querySelectorAll('[data-service-index]')];
        const update = () => {
          const index = Math.round(list.scrollLeft / list.clientWidth);
          buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
        };
        list.addEventListener('scroll', update, {passive: true, signal});
        buttons.forEach((button, index) => button.addEventListener('click', () => {
          list.scrollTo({left: index * list.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        }, {signal}));
        update();
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
